import { useEffect, useState } from 'react';
import { getCompaniesByUser } from '../../../../../app/modules/helpers/Api';

const CHAVE = 'dashboard.empresa';

export interface EmpresaOpcao {
    value: number;
    text: string;
}

/**
 * Empresa em contexto da tela inicial (D1 e D2 da spec).
 *
 * Sempre resolve uma empresa quando há ao menos uma disponível: a escolha
 * persistida, se ainda estiver na lista, ou a primeira dela. O painel não
 * abre pedindo seleção. Com uma única empresa o select nem é renderizado.
 */
export function useEmpresaSelecionada() {
    const [empresas, setEmpresas] = useState<EmpresaOpcao[]>([]);
    const [empresaId, setEmpresaId] = useState<number | null>(null);
    const [carregando, setCarregando] = useState(true);

    useEffect(() => {
        let ativo = true;

        getCompaniesByUser()
            .then((response) => {
                if (!ativo) {
                    return;
                }

                const lista: EmpresaOpcao[] = (response.data.data || []).map((item: any) => ({
                    value: Number(item.value),
                    text: String(item.text),
                }));

                setEmpresas(lista);
                setEmpresaId(resolverInicial(lista));
            })
            .catch(() => {
                if (ativo) {
                    setEmpresas([]);
                }
            })
            .finally(() => {
                if (ativo) {
                    setCarregando(false);
                }
            });

        return () => {
            ativo = false;
        };
    }, []);

    const selecionar = (id: number) => {
        setEmpresaId(id);

        try {
            localStorage.setItem(CHAVE, String(id));
        } catch (erro) {
            // localStorage indisponivel; a escolha vale so para esta sessao.
        }
    };

    return { empresas, empresaId, selecionar, carregando };
}

/**
 * A escolha persistida so vale se ainda estiver na lista: empresa que saiu do
 * vinculo do usuario e descartada. Sem escolha valida, cai na primeira da
 * lista, que Company::companiesByUser devolve ordenada por fantasy_name — o
 * painel nunca abre vazio tendo empresa disponivel.
 */
function resolverInicial(lista: EmpresaOpcao[]): number | null {
    if (lista.length === 0) {
        return null;
    }

    let persistida: string | null = null;

    try {
        persistida = localStorage.getItem(CHAVE);
    } catch (erro) {
        persistida = null;
    }

    if (persistida) {
        const id = Number(persistida);

        if (lista.some((empresa) => empresa.value === id)) {
            return id;
        }
    }

    return lista[0].value;
}
